<app-header></app-header>
<router-outlet></router-outlet>

<app-confirmmodal *ngIf="showSessionTimeOutModal" [modal]="sessionTimeOutModel"></app-confirmmodal>
<div *ngIf="showInfoPopUp">
  <app-info-pop-up [modal]="sessionTimeOutModel"></app-info-pop-up>
</div>
<div>
  <app-connectionFailurepopup></app-connectionFailurepopup>
</div>